import { Grid, useEventCallback } from '@mui/material';
import { ItalianMunicipality } from 'shell/components/shared/event-form/form-italy-event';
import { FormikErrors, FormikTouched } from 'formik';
import { DateTime } from 'luxon';
import { memo } from 'react';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import PmiTextField from 'shell/components/shared/text-field';
import { noop } from 'shell/utils/noop';

interface FormItalyEventProps {
  form: ItalianMunicipality | undefined | null;
  handleChange: (form: ItalianMunicipality) => void;
  errors?: FormikErrors<ItalianMunicipality>;
  touched?: FormikTouched<ItalianMunicipality>;
  disabled?: boolean;
  fromDate?: DateTime | null;
}

const FormItalyAuthority = ({
  form,
  handleChange,
  errors,
  touched,
  disabled = false,
  fromDate,
}: FormItalyEventProps): React.ReactElement => {
  const onChangeMunicipalityList = useEventCallback((municipality: MunicipalityAnprVM | null) => {
    handleChange({
      ...(form || {}),
      provinceCode: municipality?.provinceCode,
      municipalityDescription: municipality?.description,
      municipalityId: municipality?.id,
      province: municipality?.province,
    });
  });

  return (
    <>
      <Grid item container xs={12} spacing={0} columnSpacing={{ xs: 0, md: 1 }}>
        <Grid item xs={12} md={4}>
          <MunicipalityList
            label="Comune"
            value={
              form?.municipalityId
                ? {
                    id: form?.municipalityId,
                    description: form?.municipalityDescription || '',
                    province: form?.province || '',
                    provinceCode: form?.provinceCode,
                  }
                : null
            }
            fromDate={fromDate}
            onChange={onChangeMunicipalityList}
            error={touched?.municipalityId && Boolean(errors?.municipalityId)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiTextField
            id="province"
            label="Provincia"
            aria-label="Provincia"
            disabled
            fullWidth
            onChange={noop}
            value={form?.province || ''}
            error={touched?.province && Boolean(errors?.province)}
            helperText={errors?.province}
          />
        </Grid>
      </Grid>
    </>
  );
};

FormItalyAuthority.displayName = 'Form autorità italiana';

const FormItalyAuthorityMemo = memo(FormItalyAuthority);

export default FormItalyAuthorityMemo;
